import { useState, useCallback } from "react";

const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const MAILCHIMP_URL = process.env.REACT_APP_PUBLIC_MAILCHIMP_URL;

  const handleEmailChange = useCallback((e) => {
    setEmail(e.target.value);
    setError(null);
  }, []);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    if (!email || !email.includes("@")) {
      setError("Please enter a valid email address");
      return;
    }

    setLoading(true);

    // Create form data matching the embedded form's POST request
    const formData = new FormData();
    formData.append("EMAIL", email);
    formData.append("u", "b73ec853bd57c9a46b65d0146");
    formData.append("id", "6789891eaf");
    formData.append("f_id", "00d3c3e1f0");
    // Honeypot field (hidden anti-spam field - leave empty)
    formData.append("b_b73ec853bd57c9a46b65d0146_6789891eaf", "");

    // Use the URL without query params, send params as form data instead
    fetch("https://andrewscookin.us1.list-manage.com/subscribe/post", {
      method: "POST",
      body: formData,
      mode: "no-cors", // Required for cross-origin requests
    })
      .then(() => {
        setSuccess(true);
        setEmail("");
        setLoading(false);
      })
      .catch((err) => {
        console.error("Signup error:", err);
        setError("Failed to subscribe. Please try again.");
        setLoading(false);
      });
  }, [email]);

  if (success) {
    return (
      <div className="p-3">
        <div className="alert alert-success" role="alert">
          <strong>Success!</strong> Thanks for subscribing! We'll notify you when the tool launches.
        </div>
      </div>
    );
  }

  return (
    <div className="p-3">
      <form onSubmit={handleSubmit} className="d-flex flex-column gap-3">
        <div>
          <label htmlFor="email" className="form-label fw-medium">
            Get notified when the Recipe Search Tool launches!
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={handleEmailChange}
            placeholder="Enter your email"
            className="form-control"
            required
            autoComplete="email"
          />
        </div>

        {error && <div className="text-danger small">{error}</div>}

        {loading && <div className="text-primary small">Subscribing...</div>}

        <button type="submit" disabled={loading} className="btn btn-primary w-100">
          {loading ? "Subscribing..." : "Subscribe"}
        </button>
      </form>
    </div>
  );
};

export default NewsletterSignup;